const PLAN_DEFINITIONS = [
  {
    id: 'starter',
    name: 'Starter',
    badge: null,
    planCodes: [null, 'free', 'starter_free'],
    fallbackPriceUsd: 0,
    features: ['3 Quick interviews per month', 'Friend coach mode', 'Basic summary report'],
  },
  {
    id: 'starter_monthly',
    name: 'Starter',
    badge: null,
    planCodes: ['starter_monthly', 'sprint_weekly', 'sprint_monthly'],
    fallbackPriceUsd: 19,
    features: ['Unlimited interviews', 'Guide coach mode', 'Topic focus selection'],
  },
  {
    id: 'pro_monthly',
    name: 'Pro',
    badge: 'Most popular',
    planCodes: ['pro_monthly', 'pro_yearly'],
    fallbackPriceUsd: 49,
    features: ['Unlimited interviews', 'Challenger coach mode', 'Performance analytics'],
  },
  {
    id: 'bars_premium_monthly',
    name: 'BARS Premium',
    badge: null,
    planCodes: ['bars_premium_monthly', 'executive_quarterly', 'executive_monthly'],
    fallbackPriceUsd: 79,
    features: ['Unlimited everything', 'All coach modes', 'Expert BARS analysis'],
  },
  {
    id: 'tester',
    name: 'Tester Full Access',
    badge: 'Tester',
    planCodes: ['tester_full_eur_monthly'],
    fallbackPriceUsd: 1,
    features: ['All platform capabilities', 'Unlimited formats', 'All coach modes'],
  },
];

const FREE_PLAN_CODES = new Set(['free', 'starter_free']);

export function normalizePlanCode(planCode) {
  if (!planCode) return null;
  const normalized = String(planCode).trim().toLowerCase();
  return normalized || null;
}

export function resolvePlanDefinition(planCode) {
  const normalizedPlanCode = normalizePlanCode(planCode);
  return (
    PLAN_DEFINITIONS.find((plan) =>
      plan.planCodes.some((candidateCode) => normalizePlanCode(candidateCode) === normalizedPlanCode)
    ) || PLAN_DEFINITIONS[0]
  );
}

export function inferIsPaidPlan(capabilities = {}) {
  if (typeof capabilities?.is_paid_plan === 'boolean') {
    return capabilities.is_paid_plan;
  }
  const normalizedPlanCode = normalizePlanCode(capabilities?.plan_code);
  if (!normalizedPlanCode) return false;
  return !FREE_PLAN_CODES.has(normalizedPlanCode);
}

export function getCadenceLabel(planCode) {
  const normalized = normalizePlanCode(planCode) || '';
  if (normalized.endsWith('_weekly')) return '/week';
  if (normalized.endsWith('_monthly')) return '/month';
  if (normalized.endsWith('_quarterly')) return '/quarter';
  if (normalized.endsWith('_yearly')) return '/year';
  if (normalized.includes('free')) return 'forever';
  return '/period';
}
